"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const Node_1 = __importDefault(require("transition-common/lib/services/nodes/Node"));
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const MapCursorHelper_1 = require("../MapCursorHelper");
/* This file encapsulates map events specific for the 'nodes' section */
// Click tolerance in pixels for node detection
const CLICK_TOLERANCE = 5;
const isNodeActiveSection = (activeSection) => activeSection === 'nodes';
// TODO Should we split this in individual functions with conditions instead?
// Test the performances first
// TODO Original code in click.events.js had a _draggingEventsOrder check. Is
// it still needed? If we have problems, there should be an event handler of
// higher priority to check it before running any other
const onNodeSectionMapClick = (e) => {
    var _a, _b, _c;
    const selectedNodes = ServiceLocator_1.default.selectedObjectsManager.getSelection('nodes');
    const selectedNode = ServiceLocator_1.default.selectedObjectsManager.getSingleSelection('node');
    const isDrawPolygon = ServiceLocator_1.default.selectedObjectsManager.getSelection('isDrawPolygon');
    // Ignore the event if there is a multiple selection
    if (selectedNodes && selectedNodes.length > 0)
        return;
    // Ignore the event if we are in polygon drawing mode
    if (isDrawPolygon && isDrawPolygon.length > 0 && isDrawPolygon[0] === true)
        return;
    const features = e.target.queryRenderedFeatures([
        [e.point.x - CLICK_TOLERANCE, e.point.y - CLICK_TOLERANCE],
        [e.point.x + CLICK_TOLERANCE, e.point.y + CLICK_TOLERANCE]
    ], { layers: ['transitNodes'] });
    // TODO: If there are multiple selected features, offer the choice instead of editing the first one
    const selectedFeature = features.length > 0 ? features[0] : undefined;
    const needsShiftKeyToCreateNode = ((_c = (_b = (_a = Preferences_1.default.current) === null || _a === void 0 ? void 0 : _a.transit) === null || _b === void 0 ? void 0 : _b.nodes) === null || _c === void 0 ? void 0 : _c.shiftClickToCreateNodes) === true;
    if (selectedFeature) {
        // Clicked on a feature, edit it if possible, ignore if a node is selected and has changed
        if (selectedNode && selectedNode.hasChanged())
            return;
        // Deselect previous node and select current one
        if (selectedNode) {
            ServiceLocator_1.default.selectedObjectsManager.deselect('node');
        }
        const attributes = selectedFeature.properties || {};
        ServiceLocator_1.default.socketEventManager.emit('transitNode.read', attributes.id, null, (response) => {
            const transitNodeEdit = new Node_1.default(Object.assign({}, response.node), false, ServiceLocator_1.default.collectionManager);
            transitNodeEdit.loadFromCache(ServiceLocator_1.default.socketEventManager).then((_response) => {
                transitNodeEdit.startEditing();
                ServiceLocator_1.default.selectedObjectsManager.setSelection('node', [transitNodeEdit]);
            });
        });
    }
    else if (!selectedNode && (!needsShiftKeyToCreateNode || e.originalEvent.shiftKey)) {
        // If there is no selected node, create a new one
        const newTransitNode = new Node_1.default({
            geography: { type: 'Point', coordinates: e.lngLat.toArray() },
            color: Preferences_1.default.get('transit.nodes.defaultColor'),
            routing_radius_meters: Preferences_1.default.get('transit.nodes.defaultRoutingRadiusMeters')
        }, true, ServiceLocator_1.default.collectionManager);
        newTransitNode.startEditing();
        ServiceLocator_1.default.selectedObjectsManager.setSelection('node', [newTransitNode]);
    }
    else if (selectedNode) {
        const selectedTransitNode = selectedNode;
        if (!selectedTransitNode.isFrozen()) {
            // Otherwise, update the position of the current node
            selectedTransitNode.set('geography.coordinates', e.lngLat.toArray());
            ServiceLocator_1.default.eventManager.emit('selected.dragEnd.node', e.lngLat.toArray());
            ServiceLocator_1.default.selectedObjectsManager.setSelection('node', [selectedNode]);
        }
    }
    e.originalEvent.stopPropagation();
};
const onSelectedNodeMouseDown = (e) => {
    var _a;
    const features = e.features;
    if (!features || features.length === 0) {
        return;
    }
    const selectedNode = ServiceLocator_1.default.selectedObjectsManager.getSingleSelection('node');
    if (selectedNode &&
        e.features &&
        ((_a = e.features[0].properties) === null || _a === void 0 ? void 0 : _a.id) === selectedNode.get('id') &&
        selectedNode.get('is_frozen') !== true) {
        const map = e.target;
        ServiceLocator_1.default.eventManager.emit('map.disableDragPan');
        map._currentDraggingFeature = 'node';
        (0, MapCursorHelper_1.addDraggingClass)();
    }
};
const onSelectedNodeMouseUp = (e) => {
    const map = e.target;
    // stop drag if on edit node:
    if (map._currentDraggingFeature === 'node') {
        ServiceLocator_1.default.eventManager.emit('selected.dragEnd.node', e.lngLat.toArray());
        map._currentDraggingFeature = null;
        ServiceLocator_1.default.eventManager.emit('map.enableDragPan');
        (0, MapCursorHelper_1.removeDraggingClass)();
        (0, MapCursorHelper_1.removeHoverClass)(); // Clean up hover state since mouseleave doesn't fire during drag
        e.originalEvent.stopPropagation();
    }
};
const onSelectedNodeMouseMove = (e) => {
    const map = e.target;
    if (map._currentDraggingFeature === 'node') {
        ServiceLocator_1.default.eventManager.emit('selected.drag.node', e.lngLat.toArray());
        e.originalEvent.stopPropagation();
    }
};
const onNodeSectionContextMenu = (e) => {
    const selectedNodes = ServiceLocator_1.default.selectedObjectsManager.getSelection('nodes');
    const menu = [];
    if (selectedNodes.length > 0) {
        menu.push({
            title: 'transit:transitNode:editSelectedNodes',
            onClick: () => {
                ServiceLocator_1.default.eventManager.emit('map.editUpdateMultipleNodes');
            }
        }, {
            title: 'transit:transitNode:deleteSelectedNodes',
            onClick: () => {
                ServiceLocator_1.default.eventManager.emit('map.deleteSelectedNodes');
            }
        });
    }
    menu.push({
        title: 'transit:transitNode:deleteSelectedPolygon',
        onClick: () => {
            ServiceLocator_1.default.eventManager.emit('map.deleteSelectedPolygon');
        }
    });
    ServiceLocator_1.default.eventManager.emit('map.showContextMenu', e, menu);
};
const nodeSectionEventDescriptors = [
    { type: 'map', eventName: 'click', condition: isNodeActiveSection, handler: onNodeSectionMapClick },
    {
        type: 'layer',
        eventName: 'mousedown',
        layerName: 'transitNodesSelected',
        condition: isNodeActiveSection,
        handler: onSelectedNodeMouseDown
    },
    { type: 'map', eventName: 'mouseup', condition: isNodeActiveSection, handler: onSelectedNodeMouseUp },
    { type: 'map', eventName: 'mousemove', condition: isNodeActiveSection, handler: onSelectedNodeMouseMove },
    { type: 'map', eventName: 'contextmenu', condition: isNodeActiveSection, handler: onNodeSectionContextMenu }
];
exports.default = nodeSectionEventDescriptors;
//# sourceMappingURL=NodeSectionMapEvents.js.map